/**
 * @generated SignedSource<<c5105425128acbdc1a188ed6db147c8b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateCompanyInput = {
  name?: string | null;
  street?: string | null;
  zip?: string | null;
  city?: string | null;
  country?: string | null;
  currency?: string | null;
  timezone?: string | null;
  vatId?: string | null;
  logoId?: string | null;
  defaultRateCardId?: string | null;
  defaultHolidayCalendarId?: string | null;
  defaultExpenseCategoryId?: string | null;
  defaultRevenueMarginLow?: number | null;
  defaultRevenueMarginHigh?: number | null;
  disableNotifications?: boolean | null;
  timeRegNotificationSchedule?: string | null;
  projectOverviewNotificationSchedule?: string | null;
  contactPersonId?: string | null;
  contactName?: string | null;
  contactPhone?: string | null;
  contactEmail?: string | null;
  companyTarget?: number | null;
  monday?: number | null;
  tuesday?: number | null;
  wednesday?: number | null;
  thursday?: number | null;
  friday?: number | null;
  saturday?: number | null;
  sunday?: number | null;
  useTimeApproval?: boolean | null;
  restrictCollaboratorSeatPermissions?: boolean | null;
  useInternalTimeApproval?: boolean | null;
  useTimeOffApproval?: boolean | null;
  allUsersModifyTimeOff?: boolean | null;
  defaultUseTaskOwner?: boolean | null;
  defaultUseTaskFollowers?: boolean | null;
  harvestDeactivate?: boolean | null;
  timelogDeactivate?: boolean | null;
  economicDeactivate?: boolean | null;
  slackDeactivate?: boolean | null;
  gitlabDeactivate?: boolean | null;
  gitlabServerDeactivate?: boolean | null;
  gitlabDeleteIssues?: boolean | null;
  calendarEnabled?: boolean | null;
  calendarApiEnabled?: boolean | null;
  outlookCalendarApiEnabled?: boolean | null;
  jiraServerUrl?: string | null;
  jiraPrefixType?: string | null;
  jiraServerPrefixType?: string | null;
  tempoOauthClientId?: string | null;
  tempoOauthClientSecret?: string | null;
  salesforceDeactivate?: boolean | null;
  salesforceAutoCreate?: boolean | null;
  xeroUninstall?: boolean | null;
  githubUnauthorizedInstallation?: number | null;
  githubDeactivate?: boolean | null;
  vstsDeactivate?: boolean | null;
  vstsEstimateField?: string | null;
  oktaClientId?: string | null;
  oktaClientSecret?: string | null;
  oktaUrl?: string | null;
  oktaDomainSuffix?: string | null;
  oneloginClientId?: string | null;
  oneloginClientSecret?: string | null;
  oneloginUrl?: string | null;
  unit4Enabled?: boolean | null;
  unit4TwoWay?: boolean | null;
  unit4SyncDateLimit?: string | null;
  AADClientId?: string | null;
  AADClientSecret?: string | null;
  AADTenant?: string | null;
  isUsingSchedulingPlanMode?: boolean | null;
  isUsingProjectAllocation?: boolean | null;
  isUsingMixedAllocation?: boolean | null;
  usingProjectAllocationCreateAllocations?: boolean | null;
  userSeats?: number | null;
  collaboratorSeats?: number | null;
  virtualSeats?: number | null;
  timesheetReminderDay?: string | null;
  timesheetReminderHour?: number | null;
  timesheetReminderEnabled?: boolean | null;
  timesheetReminderIncludeToday?: boolean | null;
  projectDigestNotificationDay?: string | null;
  projectDigestNotificationHour?: number | null;
  projectDigestNotificationEnabled?: boolean | null;
  userCanUnlinkInvoice?: boolean | null;
  skillLevelsEnabled?: boolean | null;
  revenueEnabled?: boolean | null;
  timesheetsEnabled?: boolean | null;
  clientsEnabled?: boolean | null;
  betaOptIn?: boolean | null;
  weekendDisplayPerUser?: boolean | null;
  weekendDisplayShowAlways?: boolean | null;
  invoiceQuantityDecimals?: number | null;
  addFeatureFlagKeysForCypress?: ReadonlyArray<string | null> | null;
  isSSOMandatory?: boolean | null;
  sageIntacctTimeRegsFromForecast?: boolean | null;
  sageIntacctSyncOnlyApproved?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type updateCollaboratorSeatRestrictionMutation$variables = {
  input: UpdateCompanyInput;
};
export type updateCollaboratorSeatRestrictionMutation$data = {
  readonly updateCompany: {
    readonly company: {
      readonly id: string;
      readonly restrictCollaboratorSeatPermissions: boolean | null;
    } | null;
  } | null;
};
export type updateCollaboratorSeatRestrictionMutation = {
  variables: updateCollaboratorSeatRestrictionMutation$variables;
  response: updateCollaboratorSeatRestrictionMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateCompanyPayload",
    "kind": "LinkedField",
    "name": "updateCompany",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "company",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "restrictCollaboratorSeatPermissions",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateCollaboratorSeatRestrictionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateCollaboratorSeatRestrictionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6805dce4e0adc8d9e027d25fe81fe93e",
    "id": null,
    "metadata": {},
    "name": "updateCollaboratorSeatRestrictionMutation",
    "operationKind": "mutation",
    "text": "mutation updateCollaboratorSeatRestrictionMutation(\n  $input: UpdateCompanyInput!\n) {\n  updateCompany(input: $input) {\n    company {\n      id\n      restrictCollaboratorSeatPermissions\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c4e6c4c6dfcc355c9e8df8543f153e50";

export default node;
